<template>
  <b-modal
    :visible="visible"
    hide-footer
    button-size="sm"
    size="lg"
    modal-cancel="false"
    no-close-on-backdrop
    @close="close"
    id="course-syllabus-edit-modal"
  >
    <template v-slot:modal-title>Editar curso del pensum</template>
    <section class="container-fluid">
      <ValidationObserver ref="form" v-slot="{ invalid }">
        <form @submit.prevent="edit" v-if="courseSyllabus.id != null">
          <section class="row">
            <!-- Curso -->
            <div class="col">
              <div class="form-group required">
                <label class="control-label" for="course_name">Curso</label>
                <input
                  type="text"
                  :value="courseSyllabus.course.name"
                  class="form-control form-control-sm"
                  id="course_name"
                  readonly
                />
              </div>
            </div>
            <!-- Posición -->
            <div class="col">
              <div class="form-group required">
                <ValidationProvider
                  name="position"
                  rules="required"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="position">Posición</label>
                  <input
                    type="number"
                    v-model="courseSyllabus.position"
                    class="form-control form-control-sm"
                    id="position"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
          </section>
          <section class="row">
            <div class="col-4">
              <div class="form-group">
                <label for="enabled">Estado</label>
                <br />
                <CSwitch
                  :color="color"
                  v-bind="mode"
                  :checked.sync="courseSyllabus.enabled"
                  id="enabled"
                />
              </div>
            </div>
          </section>

          <b-button type="button" size="sm" variant="danger" @click="close">
            <CIcon size="sm" name="cil-x-circle" /> Cancelar
          </b-button>

          <button
            type="submit"
            class="btn btn-success btn-sm float-right"
            variant="success"
            :disabled="invalid || editLoader || !dataLoader"
          >
            <span v-if="!editLoader">
              <CIcon size="sm" name="cil-save" /> Guardar
            </span>
            <span v-if="editLoader">
              Cargando
              <CSpinner color="success" size="sm" />
            </span>
          </button>
        </form>
      </ValidationObserver>
    </section>
  </b-modal>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
  BModal,
  BButton,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
//services
import CoursesSyllabus from "@/plugins/services/courses-syllabus";
import Courses from "@/plugins/services/courses";

export default {
  name: "CourseSyllabusEditModal",
  components: {
    BFormInvalidFeedback,
    BFormSelect,
    BFormSelectOption,
    BModal,
    BButton,
  },
  props: {
    modShowCourseSyllabusEdit: { type: Boolean, required: true },
    syllabus_id: { type: Number, required: true },
    course_syllabus_id: { type: Number, required: true },
  },
  data() {
    return {
      courseSyllabus: {
        id: null,
      },
      editLoader: false,
      coursesOptions: [],
      mode: { shape: "pill" },
      color: "primary",
      dataLoader: false,
      dataEmit: { modalShow: false, data: null, status: 200 },
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowCourseSyllabusEdit;
    },
  },
  mounted() {
    this.editLoader = false;
    this.getData(this.course_syllabus_id);
    this.getCourses();
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });
  },
  methods: {
    getData(id) {
      this.dataLoader = true;
      CoursesSyllabus.getOne(id)
        .then((res) => {
          this.courseSyllabus = res.data;
          this.dataLoader = true;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Programa de curso no encontrado.");
            this.closeModal();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal();
          }
          this.dataLoader = false;
        });
    },
    edit() {
      this.editLoader = true;
      this.courseSyllabus.modified_by = this.userAuth.username;
      this.courseSyllabus.syllabus_id = this.syllabus_id;
      CoursesSyllabus.edit(this.course_syllabus_id, this.courseSyllabus)
        .then((res) => {
          this.editLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.editLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Item no encontrado.");
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al crear(500).");
            this.closeModal(null, 500);
          }
        });
    },
    getCourses() {
      Courses.selectAll()
        .then((res) => {
          this.coursesOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeModal(data = null, status = 200) {
      this.courseSyllabus = {};
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("courseSyllabusEditModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
